import { CLEAR_SUCCESSMESSAGE, SET_SUCCESSMESSAGE } from "../types";
export const clearSuccessMessage = (redirect) => (dispatch) => {
  dispatch({ type: CLEAR_SUCCESSMESSAGE });
  if (redirect) window.location.href = window.location.origin + redirect;
};

export const setSuccessMessage = (message) => (dispatch) => {
  dispatch({ type: SET_SUCCESSMESSAGE, payload: message });
};
